import React from 'react'

const Room = () => {
  return (
    <section>
    <div className="w3-container w3-margin-top" id="rooms">
      <h3>Rooms</h3>
      <p>
        Make yourself at home is our slogan. We offer the best beds in the
        industry. Sleep well and rest well.
      </p>
    </div>
    </section>
  )
}

export default Room